function productSliderInit() {
	$(".product-slider-for").slick({
		adaptiveHeight: true,
		arrows: false,
		asNavFor: ".product-slider-nav",
		draggable: false,
		fade: true,
		infinite: true,
		slidesToScroll: 1,
		slidesToShow: 1,
		autoplay: true,
		autoplaySpeed: 5000,
	});
	$(".product-slider-nav").slick({
		adaptiveHeight: true,
		arrows: false,
		asNavFor: ".product-slider-for",
		focusOnSelect: true,
		infinite: true,
		slidesToScroll: 1,
		slidesToShow: 5,
		centerMode: true,
		centerPadding: "10px",
		responsive: [
			{
				breakpoint: 1279,
				settings: {
					slidesToShow: 4,
				},
			},
			{
				breakpoint: 1023,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 575,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 479,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	});

	$("[data-product-slide='prev']").on("click", function() {
		$(".product-slider-for").slick("slickPrev");
	});
	$("[data-product-slide='next']").on("click", function() {
		$(".product-slider-for").slick("slickNext");
	});
}
